var _path, _path2, _path3, _rect, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFacts(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0833 4.25L24.0833 9.91667",
    stroke: "#9138D3",
    strokeWidth: 2.2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.91675 4.25L9.91675 9.91667",
    stroke: "#9138D3",
    strokeWidth: 2.2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.25 12.5C4.25 10.6144 4.25 9.67157 4.83579 9.08579C5.42157 8.5 6.36438 8.5 8.25 8.5H25.75C27.6356 8.5 28.5784 8.5 29.1642 9.08579C29.75 9.67157 29.75 10.6144 29.75 12.5V15.5833H4.25V12.5Z",
    stroke: "#9138D3",
    strokeWidth: 2.2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.25,
    y: 8.5,
    width: 25.5,
    height: 21.25,
    rx: 2,
    stroke: "#9138D3",
    strokeWidth: 2.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 21.25H14.1667",
    stroke: "#9138D3",
    strokeWidth: 2.2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8333 21.25H25.4999",
    stroke: "#9138D3",
    strokeWidth: 2.2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 25.5H14.1667",
    stroke: "#9138D3",
    strokeWidth: 2.2,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8333 25.5H25.4999",
    stroke: "#9138D3",
    strokeWidth: 2.2,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacts);
export default __webpack_public_path__ + "static/media/Facts.2353a75533189cbf9c3707bff388a262.svg";
export { ForwardRef as ReactComponent };